import { Component, OnInit } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ReCaptchaV3Service } from 'ngx-captcha';

import { MODAL_WIDTH } from '../../../../../common/models/constants';
import { ApiService } from '../../../../../common/services/api.service';
import { CustomValidators } from '../../../../../common/shared/custom-validators';
import { MainEventService } from '../../../../../common/shared/main-event.service';
import { NewPasswordModalComponent } from '../../components/new-password/new-password-modal.component';
import { CacheService } from '../../core/services/cache.service';
import { EnvService } from '../../core/services/env.service';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';

@UntilDestroy()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {

  return!: string;
  loginForm = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(6), CustomValidators.strongPassword]],
    email: ['', [Validators.required, CustomValidators.validateEmail]],
    type: ['password'],
  });

  company = '';
  isOtherCompany = false;

  constructor(private env: EnvService, private fb: NonNullableFormBuilder, private router: Router, private api: ApiService, public dialog: MatDialog, private ar: ActivatedRoute, private reCaptchaV3Service: ReCaptchaV3Service, private cache: CacheService) {
  };

  ngOnInit(): void {
    MainEventService.login.emit(); // Si estas aqui, hay que vaciar cualquier usuario previo

    // miramos si es el login específico de alguna compañía
    const pathname = window.location.pathname;
    const pathParts = pathname.split('/').filter(p => p);

    this.company = pathParts.length > 0 ? pathParts[0] : '';
    this.isOtherCompany = this.company !== ('login' || '');

    this.ar.queryParams.pipe(untilDestroyed(this)).subscribe((queryParams) => {
      this.return = queryParams.return || '/record-list';
      if (queryParams.locale) this.cache.locale = queryParams.locale;
      if (queryParams.code) this.dialog.open(NewPasswordModalComponent, { ...MODAL_WIDTH, disableClose: true, data: queryParams });
    });
  }

  async sendLogin() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return this.api.logError('formErrors.invalidForm');
    }
    const captchaResponse = this.env.captchaKey ? await this.reCaptchaV3Service.executeAsPromise(this.env.captchaKey, 'login', { useGlobalDomain: true }) : '';
    const data = this.loginForm.getRawValue();
    data.type = 'password';
    data.email = data.email?.trim();

    this.api.login(data, captchaResponse).subscribe(res => {
      this.cache.setUser(res.user);
      MainEventService.login.emit(res);
      this.router.navigateByUrl(this.return);
    });
  }

  // esta modal es más pequeña que el resto, NO es un error
  openRecoveryPassword() {
    this.dialog.open(PasswordRecoveryComponent, { width: '25vw', minHeight: 300, disableClose: true });
  }
}
